import React from "react";
import { _t } from "../../../languageHandler";

interface IProps {
    w?: number;
    h?: number;
    message?: string;
    /** Posizione del messaggio rispetto allo spinner: 'top' | 'bottom' | 'left' | 'right' */
    messagePosition?: "top" | "bottom" | "left" | "right";
    /** Spinner si comporta come dialog, ma non chiama mai onFinished */
    onFinished?: VoidFunction;
}

const FLEX_ROW: React.CSSProperties = { display: "flex", alignItems: "center", gap: 8 };
const FLEX_COL: React.CSSProperties = { display: "flex", flexDirection: "column", alignItems: "center", gap: 8 };

const Spinner = React.memo<IProps>(({ w = 32, h = 32, message, messagePosition = "left" }) => {
    const spinner = (
        <div
            key="spinner"
            className="mx_Spinner_icon"
            style={{ width: w, height: h }}
            aria-label={_t("common.loading")}
            role="progressbar"
            data-testid="spinner"
        />
    );

    const msg = message ? (
        <div key="message" className="mx_Spinner_Msg">
            {message}
        </div>
    ) : null;

    const isRow = messagePosition === "left" || messagePosition === "right";
    const wrapperStyle = isRow ? FLEX_ROW : FLEX_COL;
    const children = messagePosition === "left" || messagePosition === "top"
        ? [msg, spinner]
        : [spinner, msg];

    return (
        <div className="mx_Spinner" style={wrapperStyle}>
            {children}
        </div>
    );
});

Spinner.displayName = "Spinner";

export default Spinner;